(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ivy-home"] && !Shopify.designMode) return;
  try {
    
function bindIvyEnterprise(root) {
  if (root.dataset.billingBound) return;
  root.dataset.billingBound = 'true';
  const waitlist = root.querySelector('.ivy-waitlist');
  root.querySelectorAll('a[href^="#ivy-waitlist-"]').forEach(link => link.addEventListener('click', () => {
    window.setTimeout(() => waitlist?.querySelector('input[type="email"]')?.focus({ preventScroll: true }), 0);
  }));
  if (waitlist?.querySelector('[role="status"], [role="alert"]')) {
    waitlist.scrollIntoView({ block: 'center' });
    waitlist.querySelector('[role="status"]')?.focus({ preventScroll: true });
  }
  const carousel = root.querySelector('.ivy-plans-grid');
  const cards = carousel ? Array.from(carousel.querySelectorAll('.ivy-plan')) : [];
  const previousPlan = root.querySelector('[data-plans-prev]');
  const nextPlan = root.querySelector('[data-plans-next]');
  if (carousel && cards.length && previousPlan && nextPlan) {
    const activeIndex = () => {
      const origin = cards[0].offsetLeft;
      return cards.reduce((closest, card, index) => Math.abs(card.offsetLeft - origin - carousel.scrollLeft) < Math.abs(cards[closest].offsetLeft - origin - carousel.scrollLeft) ? index : closest, 0);
    };
    const refreshPlans = () => {
      const index = activeIndex();
      root.querySelector('[data-plans-current]').textContent = String(index + 1);
      root.querySelector('[data-plans-total]').textContent = String(cards.length);
      previousPlan.disabled = index === 0;
      nextPlan.disabled = index === cards.length - 1;
    };
    const movePlan = direction => {
      const index = Math.max(0, Math.min(cards.length - 1, activeIndex() + direction));
      carousel.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previousPlan.addEventListener('click', () => movePlan(-1));
    nextPlan.addEventListener('click', () => movePlan(1));
    let plansFrame = 0;
    carousel.addEventListener('scroll', () => {
      if (plansFrame) return;
      plansFrame = window.requestAnimationFrame(() => { plansFrame = 0; refreshPlans(); });
    }, { passive: true });
    refreshPlans();
  }
  const updateBilling = period => {
    root.querySelectorAll('.ivy-price[data-monthly]').forEach(price => {
      price.querySelector('.ivy-price-amount').textContent = '$' + Number(price.dataset[period]).toLocaleString('en-US', { minimumFractionDigits: Number.isInteger(Number(price.dataset[period])) ? 0 : 2, maximumFractionDigits: 2 });
      const suffix = price.querySelector('.ivy-price-period');
      suffix.textContent = period === 'annual' ? suffix.dataset.annualLabel : suffix.dataset.monthlyLabel;
    });
    root.querySelectorAll('[data-regular-monthly]').forEach(regular => {
      const value = period === 'annual' ? regular.dataset.regularAnnual : regular.dataset.regularMonthly;
      regular.querySelector('[data-regular-amount]').textContent = '$' + Number(value).toLocaleString('en-US');
      const suffix = regular.querySelector('[data-regular-period]');
      suffix.textContent = period === 'annual' ? suffix.dataset.annualLabel : suffix.dataset.monthlyLabel;
    });
    root.querySelectorAll('[data-monthly-note]').forEach(note => { note.textContent = period === 'annual' ? note.dataset.annualNote : note.dataset.monthlyNote; });
    root.querySelectorAll('.ivy-membership-cart').forEach(form => {
      const select = form.querySelector('select[name="id"]');
      if (!select) return;
      const option = Array.from(select.options).find(option => option.dataset.period === period);
      select.value = option ? option.value : '';
      const button = form.querySelector('button[type="submit"]');
      if (button) button.disabled = !option || option.disabled;
      const schedule = form.querySelector('input[name="selling_plan"]');
      if (schedule) schedule.value = option?.dataset.sellingPlan || '';
      if (button) button.disabled = !option || option.disabled || !schedule?.value;
      const notice = form.querySelector('[data-subscription-notice]');
      if (notice) notice.hidden = Boolean(option && !option.disabled && schedule?.value);
    });
  };
  root.querySelectorAll('.ivy-billing-toggle input').forEach(input => input.addEventListener('change', () => updateBilling(input.value)));
  root.querySelectorAll('.ivy-membership-cart').forEach(form => form.addEventListener('submit', event => {
    const variant = form.querySelector('select[name="id"]')?.selectedOptions[0];
    const schedule = form.querySelector('input[name="selling_plan"]');
    if (!variant || variant.disabled || !schedule?.value || schedule.value !== variant.dataset.sellingPlan) event.preventDefault();
  }));
  updateBilling(root.querySelector('.ivy-billing-toggle input:checked')?.value || 'monthly');
}
document.querySelectorAll('.ivy-store-home').forEach(bindIvyEnterprise);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.ivy-store-home').forEach(bindIvyEnterprise));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
